/*
 * @Author: YMJ
 * @Date: 2020-10-24 17:14:00
 */
import axios from 'axios';
import store from '@/store/index.js';
import router from '@/router/index.js';
import {getToken, removeToken} from '@/utils/auth.js';
import {Loading, Message} from 'element-ui';

export const baseURL = process.env.VUE_APP_URL

const whiteList = ['/authentication/pass', '/common/render', '/common/login'];
//使用create方法创建axios实例
const Service = axios.create({
    timeout: 60000, // 请求超时时间
    baseURL: baseURL,
    method: 'post',
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    }
})
let loading;
let _status = true;

function startLoading() {    //使用Element loading-start 方法
    if (!_status) return;
    loading = Loading.service({
        lock: true,
        text: '拼命加载中...',
        background: 'rgba(0, 0, 0, 0.8)'
    })
}

function endLoading() {    //使用Element loading-close 方法
    _status = true
    if (loading && loading.close) loading.close();
}

function isWhite(url) {
    let _statu = true;
    whiteList.forEach(item => {
        if (url.indexOf(item) !== -1) {
            _statu = false;
        }
    });
    return _statu;
}

// 添加请求拦截器
Service.interceptors.request.use(config => {
    // 判断是否需要token
    let _token = store.state.user.token || getToken()
    if (isWhite(config.url) && !_token) {
        // 判断是否有token
        Message.error('暂未登录或登录失效!')
        return router.push('/login');
    }
    config.headers['Authorization'] = _token == null ? '' : _token;
    startLoading()
    return config
}, error => {
    console.log(error);
})
// 添加响应拦截器
Service.interceptors.response.use(response => {
    endLoading();
    let message = '';
    switch (response.data.code) {
        case 400:
            message = '请求错误';
            break
        case 401:
            message = '未授权，请登录';
            break
        case 403:
            message = '拒绝访问';
            break
        case 404:
            message = `请求地址出错: ${error.response.config.url}`;
            break
        case 408:
            message = '请求超时';
            break
        case 500:
            message = '服务器内部错误';
            break
        case 501:
            message = '服务未实现';
            break
        case 502:
            message = '网关错误';
            break
        case 503:
            message = '服务不可用';
            break
        case 504:
            message = '网关超时';
            break
        case 505:
            message = 'HTTP版本不受支持';
            break
        default:
            break
    }
    if (message !== '') {
        Message.error(message);
        if (response.data.code == 401) {
            removeToken('token')
            store.commit('user/REMOVE_TOKEN')
            router.push('/login')
            return;
        }
        return Promise.reject(message);
    }
    if (response.data.code != 0) {
        if (response.data.code == 100401) {
            location.reload()
        }
        Message.error(response.data.message);
        return Promise.reject(response.data);
    }
    return response.data;
}, error => {
    endLoading();
    return Promise.reject(error);
})


/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param status
 * @param config
 */
export function get(url, params, status = true, config) {
    _status = status
    return Service({
        method: "GET",
        url: url,
        params: params,
        ...config
    })
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
    return Service({
        method: "POST",
        url: url,
        data: params
    })
}

/**
 * 封装patch请求
 * @param url
 * @param params
 * @returns {Promise}
 */
export function del(url, params) {
    return Service({
        method: "DELETE",
        url: url,
        params: params
    })
}

/**
 * put 请求
 * @param  url
 * @param  params
 */
export function put(url, params) {
    return Service({method: "PUT", url: url, data: params})
}


export function download(url) {
    const _service = axios.create({
        timeout: 7000,
        baseURL: process.env.VUE_APP_URL,
        method: 'post',
        headers: {
            'Authorization': store.state.user.token || getToken(),
            'Content-Type': 'application/json;charset=UTF-8'
        }
    })
    return _service({
        url: url,
        responseType: 'blob'
    })
}
